<template>
    <div class="hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10">
        <div class="grid grid-rows-7 h-full">
            <MenuButton :to="{name:'Home', params: {id}}" icon-class="icon-home" tooltip="Home"></MenuButton>
            <div class="flex-grow grid grid-rows-6 row-span-6">
                <MenuButton :to="{name:'ListaProgetti'}" icon-class="icon-catena_orizzontale" tooltip="Progetti"></MenuButton>
                <MenuButton :to="{name:'DettaglioProgetto', params: {id}}" icon-class="icon-catena_verticale" tooltip="Sottoprogetti"></MenuButton>
                <ProfileMenuButton class="row-start-6" :notification="meCounters?.notification_counter > 0"></ProfileMenuButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import MenuButton from "@/components/MenuButton.vue";
import ProfileMenuButton from "@/components/ProfileMenuButton.vue";
import { mapGetters } from 'vuex';

@Options({
    name:'DettaglioProgettoMenu',
    components:{
        MenuButton,
        ProfileMenuButton
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        id: String
    },
    computed: {
        ...mapGetters([
            'meCounters',
        ]),
    },
})
export default class ProgettiMenu extends Vue {
    private $store: any;

    toggle() {
        this.$store.commit('toggle_menu')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
